'use client';
import { Flex, Skeleton } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { WidgetContainer } from '@/components/modules/Widget/Container';
import { useGetResearchAuthors } from '@/modules/Author/http/client/useGetResearchAuthors';
import { IfRender } from '@/utils/jsx';
import { AuthorCard } from './Card';

export const AuthorsWidget = () => {
  const t = useT();
  const { data: authors = [], isLoading } = useGetResearchAuthors();

  if (isLoading) {
    return (
      <WidgetContainer
        containerId="Authors"
        title={t('widgets.AuthorsWidget.title')}
        sliderProps={{ slidesGap: 26 }}
      >
        {Array.from({ length: 10 }).map((_, idx) => (
          <Flex key={idx} flexDir="column" alignItems="center" gap="12">
            <Skeleton w="7.5rem" h="7.5rem" borderRadius="5em" />
            <Skeleton w="5.625rem" h="0.625rem" borderRadius="0.125rem" />
          </Flex>
        ))}
      </WidgetContainer>
    );
  }

  return (
    <IfRender condition={authors.length > 0}>
      <WidgetContainer
        containerId="Authors"
        title={t('widgets.AuthorsWidget.title')}
        sliderProps={{ slidesGap: 26 }}
      >
        {authors.map(({ id, name, slug, thumb }) => (
          <AuthorCard key={id} name={name} slug={slug} thumb={thumb} />
        ))}
      </WidgetContainer>
    </IfRender>
  );
};
